var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3786 10.8668H8.82129C6.86663 10.8668 5 12.5256 5 14.4829V14.779C5 15.267 5.3707 15.6671 5.85875 15.6671H12.0934C11.9895 15.3764 11.9334 15.0618 11.9334 14.7338C11.9334 13.1898 13.1893 11.9336 14.7336 11.9336C14.8349 11.9336 14.9336 11.9391 15.0297 11.9469C14.3173 11.2853 13.36 10.8668 12.3786 10.8668ZM10.5999 5C9.12787 5 7.93325 6.19462 7.93325 7.66664C7.93325 9.13866 9.12787 10.3333 10.5999 10.3333C12.0719 10.3333 13.2666 9.13866 13.2666 7.66664C13.2666 6.19462 12.0719 5 10.5999 5ZM14.7333 12.4667C13.4814 12.4667 12.4667 13.4814 12.4667 14.7333C12.4667 15.9853 13.4816 17 14.7333 17C15.9851 17 17 15.9853 17 14.7336C17 13.4816 15.9853 12.4667 14.7333 12.4667ZM16.017 14.2917L14.5637 15.745C14.46 15.8488 14.2903 15.8488 14.1866 15.745L13.4551 15.0136C13.3514 14.9098 13.3514 14.7402 13.4551 14.6364L13.6437 14.4479C13.7474 14.3441 13.917 14.3441 14.0208 14.4479L14.3749 14.802L15.4512 13.7258C15.5549 13.6221 15.7246 13.6221 15.8283 13.7258L16.0168 13.9144C16.1207 14.0181 16.1207 14.188 16.017 14.2917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified1);
export default __webpack_public_path__ + "static/media/verified1.30788d88116011eecd4d22171d7f8404.svg";
export { ForwardRef as ReactComponent };